export const MAINTENANCE_RETURN_KEY = "maintenance:returnTo";
